import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
        appBar: {
            background: "#D4EEFF",
            boxShadow: "0px 0px 20px rgba(110, 132, 188, 0.22), 0px 0px 4px rgba(0, 0, 0, 0.12)",
            transition: theme.transitions.create(['margin', 'width'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
        },
        title: {
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: "bold",
            fontSize: "32px",
            textTransform: "uppercase",
            color: "black",
        },
        grow: {
            flexGrow: 2,
        }
    ,
    chosenButton: {
    backgroundColor: 'rgb(140, 209, 255)',
        marginRight:
    theme.spacing(3),
}
,
menuItem: {
    marginRight: theme.spacing(3),
}
,
}))
;
